<template>
  <div class="container">
    <section class="blogs-list">
      <h2>{{ blogsList.title }}</h2>
      <div v-if="blogsList.description" class="d-flex blogs-list__description-container">
        <span class="blogs-list__icon-container">
          <PencilIcon />
        </span>
        <div class="blogs-list__description" v-html="blogsList.description"></div>
      </div>
      <div class="search-section__search">
        <div
          class="d-flex align-items-center search-section-title-container"
          :class="blogsList.search.description ? '' : 'mb-4'"
        >
          <span>
            <SearchResultIcon v-if="blogsList.category" />
          </span>
          <p class="h4 mb-0">{{ blogsList.search.title }}</p>
        </div>
        <p v-if="blogsList.search.description">{{ blogsList.search.description }}</p>
        <SearchSection
            :input="{value: state.search.keywords, placeholder: blogsList.search.input.placeholder, class: 'search-section__search-input', autocomplete: false}"
            :button="{
              text: blogsList.search.searchButton.text,
              class: 'search-section__search-btn ms-lg-3 mt-3 mt-lg-0 w-100-lg-initial',
            }"
            @search="handleSearchClick"
            @changeInput="(text) => handleInput(text)"
        />
        <a
            class="cursor-pointer search-section__back-btn"
            v-if="state.showResult || getParam('pageNumber')"
            @click="handleBackButton"
        >
          <ArrowLeftLarge class="search-section__back-btn-arrow" />
          {{ blogsList.backButton.text }}
        </a>
      </div>
      <div class="row blog-items">
        <BlogListItem v-if="blogs" v-for="blog in blogs.result" :blog="blog" />
      </div>
      <div class="pagination-wrapper py-5 d-flex justify-content-center" >
        <paginate
            v-if="blogs && blogs.pageCount > 1"
            v-model="state.search.pageNumber"
            :page-count="state.search.pageCount"
            :page-range="3"
            :margin-pages="3"
            :click-handler="handleSearchClick"
            prev-text="Previous"
            next-text="Next"
            prev-class="btn-prev"
            next-class="btn-next"
            active-class="btn-active"
        />
      </div>
    </section>
  </div>
</template>

<script setup>
  import BlogListItem from './BlogListItem.vue';
  import SearchSection from "@/components/common/SearchSection";
  import ArrowLeftLarge from "@/assets/icons/arrow-left-large.vue";
  import SearchResultIcon from "@/assets/icons/search-result-icon.vue";
  import {onMounted, reactive, watch} from "vue";
  import useLoadData from "@/composables/useLoadData";
  import api from "@/config/api";
import PencilIcon from '@/assets/icons/pencil-icon.vue';

  const props = defineProps({
    blogsList: {
      title: String,
      description: String,
      blogs: Array,
      category: String,
      search: {
        title: String,
        description: String,
        url: String,
        input: {
          placeholder: String,
          keywords: String,
        },
        searchButton: {
          text: String,
          link: String,
        },
      },
      backButton: {
        text: String,
        link: String,
      },
    }
  })

  const getParam = (paramName) => new URL(window.location).searchParams.get(paramName)

  const state = reactive({
    showResult: false,
    search: {
      keywords: getParam('keywords') || '',
      pageNumber: +getParam('pageNumber') || 1,
      category: getParam('Category') || props.blogsList.category,
      pageCount: 0,
    }
  })

  const getConfig = (stateObject) => {
    return {
      ...(stateObject.search.keywords.length > 0 && {keywords: stateObject.search.keywords}),
      ...(stateObject.search.category.length > 0 && {category: stateObject.search.category}),
      page: stateObject.search.pageNumber
    }
  }

  const { data: blogs, fetchData: fetchBlogs } = useLoadData(
      api.blogList,
      {
        method: 'get',
        params: getConfig(state)
      }
  )

  const handleInput = (text) => state.search.keywords = text

  const handleSearchClick = () => {
    const url = new URL(window.location);
    url.searchParams.set('pageNumber', state.search.pageNumber.toString());
    url.searchParams.set('keywords', state.search.keywords);
    props.blogsList.category && url.searchParams.set('Category', props.blogsList.category);

    state.showResult = true;

    window.location.search = url.searchParams;
  }

  function handleBackButton(){
    state.showResult = false
    state.search.keywords = ''
    state.search.pageNumber = 1

    window.location.search = '';
    
    fetchBlogs({
      url: api.blogList,
      method: 'get',
      params: getConfig(state)
    })
  }

  onMounted(async () => {
    await fetchBlogs({
      url: api.blogList,
      method: 'get',
      params: getConfig(state)
    })

    state.search.pageCount = blogs.value.pageCount
    state.search.pageNumber = blogs.value.currentPage
  })
</script>
